import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface FormFieldWrapperProps {
  label: string;
  explanation?: string;
  fieldError?: string | null;
  showError?: boolean;
  className?: string;
  children: ReactNode;
}

export function FormFieldWrapper({
  label,
  explanation,
  fieldError,
  showError,
  className,
  children,
}: FormFieldWrapperProps) {
  return (
    <label className={twMerge('block', 'group', 'w-full', className)}>
      <div className="grid gap-x-2 items-center grid-cols-[max-content_1fr]">
        <div className="font-bold text-white text-sm">{label}</div>
        {showError && fieldError && (
          <div className="truncate text-right text-rose-500 text-sm">
            {fieldError}
          </div>
        )}
      </div>
      {explanation && (
        <div className="text-sm text-neutral-400">{explanation}</div>
      )}
      <div className="mt-1">{children}</div>
    </label>
  );
}
